export const ATTRIBUTION_STORAGE_KEY = "studyradar_first_touch_attribution";

export const UTM_FIELDS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
];

const CAPTURE_FIELDS = [...UTM_FIELDS, "ref", "insight_slug"];

function getBrowserSearch() {
  try {
    return typeof window !== "undefined" ? window.location.search : "";
  } catch (error) {
    return "";
  }
}

function getBrowserStorage() {
  try {
    return typeof window !== "undefined" ? window.localStorage : null;
  } catch (error) {
    return null;
  }
}

function readStoredAttribution(storage) {
  const rawValue = storage.getItem(ATTRIBUTION_STORAGE_KEY);
  if (!rawValue) return null;

  let parsed;
  try {
    parsed = JSON.parse(rawValue);
  } catch (error) {
    return null;
  }

  const hasAttributionValue = CAPTURE_FIELDS.some(
    (field) => typeof parsed?.[field] === "string" && parsed[field].trim()
  );
  if (!parsed || typeof parsed !== "object" || !hasAttributionValue) {
    return null;
  }

  return parsed;
}

export function captureFirstTouchAttribution(
  search = getBrowserSearch(),
  storage = getBrowserStorage()
) {
  if (!storage) return null;

  try {
    const existing = readStoredAttribution(storage);
    if (existing) {
      if (existing.ref && !storage.getItem("referral_code")) {
        storage.setItem("referral_code", existing.ref);
      }
      return existing;
    }

    const params = new URLSearchParams(search);
    const captured = CAPTURE_FIELDS.reduce((values, field) => {
      const value = params.get(field)?.trim();
      if (value) values[field] = value;
      return values;
    }, {});

    if (Object.keys(captured).length === 0) return null;

    const attribution = {
      ...captured,
      captured_at: new Date().toISOString(),
    };

    storage.setItem(ATTRIBUTION_STORAGE_KEY, JSON.stringify(attribution));
    if (captured.ref && !storage.getItem("referral_code")) {
      storage.setItem("referral_code", captured.ref);
    }

    return attribution;
  } catch (error) {
    // Attribution must never prevent the application or signup from loading.
    return null;
  }
}

export function getSignupAttribution(
  storage = getBrowserStorage()
) {
  if (!storage) return {};

  try {
    const stored = readStoredAttribution(storage);
    if (!stored) return {};

    return UTM_FIELDS.reduce((values, field) => {
      if (typeof stored[field] === "string" && stored[field].trim()) {
        values[field] = stored[field].trim();
      }
      return values;
    }, {});
  } catch (error) {
    return {};
  }
}
